import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';
import {setPartTypeLoading} from './LoadingReducer';

export const setPartItem = createAction('SET_PART_ITEM');
export const loadPartItem = (action = {}) => (dispatch, getState) => {
  const {partID, partType, carSize, carType, carID} = action;

  dispatch(setPartTypeLoading({loading: true}));
  axios.get(
      `/damage/part_table/${partID}/${partType}?cat_id=${carID}&car_type=${carType}&format=json`).
      then((response) => {
        const data = response.data && response.data.data
                     && response.data.data.list || [];
        dispatch(setPartItem({
          data: data,
          payload: action,
        }));
        dispatch(setPartTypeLoading({loading: false}));
      }).
      catch((error) => {
        console.error(error);
      });
};

export const PartItemReducer = (defaultState) => handleActions({
  loadPartItem,
  [setPartItem](state, action = {}) {
    const {data, payload} = action.payload || {};
    console.log(action);
    return data || [];
  },
}, defaultState);

export default PartItemReducer;


// WEBPACK FOOTER //
// ./src/stores/CarDamage/PartItemReducer.js